module.exports = __webpack_public_path__ + "assets/img/mr11.cca4d566.png";